/**
 * Default: layout > Footer
 */

import {observeInView} from '@ifabnpm/bootstrap/utils/observer.js';

import SelectorEngine from '@ifabnpm/bootstrap/dom/selector-engine.js';
import Manipulator from '@ifabnpm/bootstrap/dom/manipulator.js';

// -------
// Privat
// -------

let footerContainer = null;

// -------
// Public
// -------

const footer = async () => {
	footerContainer = footerContainer || SelectorEngine.findOne('#page-footer');

	if (footerContainer)  {
		//
		// Überwachung wann der Footer im ´Viewport´ erscheint.
		//

		// Observer initialisieren.
		observeInView(footerContainer, {
			onEnterViewport: () => {
				Manipulator.addClass(document.documentElement, 'page-footer-in-view');
			},
			onLeaveViewport: () => {
				Manipulator.removeClass(document.documentElement, 'page-footer-in-view');
			},
			observer       : {
				threshold: 0
			}
		});
	}

	return footerContainer;
};

// Export
export default footer;
